import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import en from './locales/en'
//import ru from './locales/ru'
import uk from './locales/uk'

import defaultLightTheme from './themes/defaultLightTheme'
import defaultDarkTheme from './themes/defaultDarkTheme'

const vuetify = createVuetify({
	components,
	directives,
	theme: {
        defaultTheme: 'defaultLightTheme',
		themes: { defaultLightTheme, defaultDarkTheme },
	},
	icons: {
		defaultSet: 'mdi',
	},
	locale: {
		locale: 'uk',
		messages: { en, uk },
		rtl: {
			uk: false,
		},
	},
})

export default vuetify